const $ = jQuery.noConflict();

$(document).ready(function (){

  //store doms into variables
  let $sharebtn = $('#research-article .share-container .share-button'),
  	$dropdown = $('#research-article .share-container .dropdown'),
  	$copy = $('#research-article .share-container .dropdown .copy'),
  	$facebook = $('#research-article .share-container .dropdown .facebook'),
  	$x = $('#research-article .share-container .dropdown .x'),
  	$linkedin = $('#research-article .share-container .dropdown .linkedin');

  //show and hide dropdown
  $sharebtn.click(function () {
  	$dropdown.toggleClass('show');
  });

  //copy link
  $copy.click(function () {

  	const url = window.location.href;
  	navigator.clipboard.writeText(url)
    	.then(() => alert('Link copied to clipboard!'))
    	.catch(err => console.error('Failed to copy: ', err));

  	$dropdown.removeClass('show');
  	return false;
  });

  //facebook share
  $facebook.click(function () {

  	const url = encodeURIComponent(window.location.href);
    const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(shareUrl, '_blank');

  	//hide dropdown
  	$dropdown.removeClass('show');
  	return false;
  });

  //x
  $x.click(function () {

  	const url = encodeURIComponent(window.location.href);
   	const text = encodeURIComponent('Check out this page!');
   	const shareUrl = `https://x.com/intent/post?url=${url}&text=${text}`;
   	window.open(shareUrl, '_blank');

  	//hide dropdown
  	$dropdown.removeClass('show');
  	return false;
  });

  //linkedin
  $linkedin.click(function () {

  	const url = encodeURIComponent(window.location.href);
    const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
    window.open(shareUrl, '_blank');

  	//hide dropdown
  	$dropdown.removeClass('show');
  	return false;
  });



  //load more stories
  let $loadMore = $('.load-more .btn'),
    $hidden = $('.stories-list li');

  $loadMore.click(function () {

    $hidden.removeClass('hide');
    $(this).hide();

    return false;
  });

  // lazy load images
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {

      if (entry.isIntersecting) {
        const img = entry.target;
        // img.src = img.dataset.src;
        img.classList.add('fade-in'); // Optional: add CSS transition
        observer.unobserve(img); // Stop watching after it loads
      }
    });
  });
  document.querySelectorAll('.lazy-load').forEach(img => observer.observe(img));

});